export default __webpack_public_path__ + "static/media/director_esp.57ac0297.jpg";